// 模型缓存管理工具
class ModelCacheManager {
    constructor() {
        this.cacheStorageKey = 'eye-gazer-model-cache';
        this.modelVersion = '1.0'; // 模型版本，用于缓存失效
    }

    // 检查浏览器缓存 API 支持
    get isCacheSupported() {
        return 'caches' in window;
    }

    // 获取缓存实例
    async getCache() {
        if (!this.isCacheSupported) {
            return null;
        }
        return await caches.open(this.cacheStorageKey);
    }

    // 预缓存模型文件
    async precacheModel(modelUrl = 'model/L2CSNet_gaze360.onnx') {
        try {
            const cache = await this.getCache();
            if (!cache) {
                console.log('浏览器不支持 Cache API，使用默认缓存策略');
                return;
            }

            // 检查是否已经缓存
            const cachedResponse = await cache.match(modelUrl);
            if (cachedResponse) {
                console.log('模型文件已在缓存中');
                return;
            }

            // 预加载模型文件
            const response = await fetch(modelUrl, {
                cache: 'force-cache',
                headers: {
                    'Cache-Control': 'max-age=31536000'
                }
            });

            if (response.ok) {
                await cache.put(modelUrl, response.clone());
                console.log('模型文件已成功缓存');
            }
        } catch (error) {
            console.warn('预缓存模型失败:', error);
        }
    }

    // 清理过期缓存
    async clearExpiredCache() {
        try {
            const cache = await this.getCache();
            if (!cache) return;

            const requests = await cache.keys();
            for (const request of requests) {
                const response = await cache.match(request);
                if (response) {
                    const cacheDate = response.headers.get('date');
                    if (cacheDate) {
                        const age = Date.now() - new Date(cacheDate).getTime();
                        // 如果缓存超过30天，删除它
                        if (age > 30 * 24 * 60 * 60 * 1000) {
                            await cache.delete(request);
                            console.log('已清理过期缓存:', request.url);
                        }
                    }
                }
            }
        } catch (error) {
            console.warn('清理缓存失败:', error);
        }
    }

    // 获取缓存信息
    async getCacheInfo() {
        try {
            const cache = await this.getCache();
            if (!cache) return null;

            const requests = await cache.keys();
            const info = {
                count: requests.length,
                urls: requests.map(req => req.url)
            };

            return info;
        } catch (error) {
            console.warn('获取缓存信息失败:', error);
            return null;
        }
    }
}

// 导出单例实例
export const modelCacheManager = new ModelCacheManager();

// 在应用启动时立即开始预缓存
if (typeof window !== 'undefined') {
    // 延迟执行以避免阻塞初始加载
    setTimeout(() => {
        modelCacheManager.precacheModel();
        modelCacheManager.clearExpiredCache();
    }, 1000);
}
